/* Candy hero slider: fade rotation between offer slides.
   Pauses on hover/focus, honors prefers-reduced-motion, dots + play/pause. */
class CandyHeroSlider extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
    if (this.slides.length < 2) return;

    this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
    this.playButton = this.querySelector('[data-hero-playpause]');
    this.index = 0;
    this.timer = null;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.autoplayEnabled = this.dataset.autoplay === 'true' && !this.reducedMotion;
    this.playing = false;
    this.interval = (parseInt(this.dataset.interval, 10) || 6) * 1000;

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        this.goTo(i);
        this.restart();
      });
    });

    if (this.playButton) {
      if (!this.autoplayEnabled) {
        this.playButton.hidden = true;
      } else {
        this.playButton.addEventListener('click', () => {
          if (this.playing) {
            this.stop();
            this.autoplayEnabled = false;
          } else {
            this.autoplayEnabled = true;
            this.start();
          }
          this.updatePlayButton();
        });
      }
    }

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) this.start();
    });

    this.start();
    this.updatePlayButton();
  }

  disconnectedCallback() {
    this.stop();
  }

  goTo(index) {
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => {
      const active = i === this.index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.index);
      dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
    });
  }

  start() {
    if (!this.autoplayEnabled || this.timer) return;
    this.playing = true;
    this.timer = setInterval(() => this.goTo(this.index + 1), this.interval);
  }

  stop() {
    this.playing = false;
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  restart() {
    if (!this.autoplayEnabled) return;
    this.stop();
    this.start();
  }

  updatePlayButton() {
    if (!this.playButton) return;
    const playIcon = this.playButton.querySelector('[data-icon-play]');
    const pauseIcon = this.playButton.querySelector('[data-icon-pause]');
    if (playIcon) playIcon.hidden = this.autoplayEnabled;
    if (pauseIcon) pauseIcon.hidden = !this.autoplayEnabled;
    this.playButton.setAttribute(
      'aria-label',
      this.autoplayEnabled ? 'Pause slideshow' : 'Play slideshow'
    );
  }
}

customElements.define('candy-hero-slider', CandyHeroSlider);
